import { PROJECT_DETAILS_PREFIX } from '../../../navigation/project/utils';

export function getActivePathnames(pathname: string, projectSlug?: string) {
  if (!projectSlug) {
    return [pathname];
  }
  const withoutProjectPath = pathname.replace(`${PROJECT_DETAILS_PREFIX}/${projectSlug}`, '');
  return [withoutProjectPath, `/p/0${withoutProjectPath}`, pathname];
}
